import React from 'react'

const AppLink = ({
  className,
  link,
  showMobile,
  showDesktop,
  srcMobile,
  srcDesktop,
  title,
}) => (
  <a
    href={link}
    target="_blank"
    rel="noopener noreferrer"
    className={className}
  >
    <h3>{title}</h3>
    <img src={srcMobile} alt="" className={showMobile} />
    <img src={srcDesktop} alt="" className={showDesktop} />
  </a>
)

export default AppLink
